import React, { createContext, useState, useContext, useEffect } from 'react';
import { API_ORIGIN } from '../config';

const ActiveFormsContext = createContext();

export const useActiveForms = () => {
  const context = useContext(ActiveFormsContext);
  if (!context) {
    throw new Error('useActiveForms must be used within an ActiveFormsProvider');
  }
  return context;
};

export const ActiveFormsProvider = ({ children }) => {
  const [activeForms, setActiveForms] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchActiveForms = async () => {
    try {
      const response = await fetch(`${API_ORIGIN}/api/clientadmin/activeForms`, {
        method: 'GET',
      });
      const data = await response.json();
      
      if (data.success) {
        setActiveForms(data.forms || []);
      }
    } catch (error) {
      // ignore
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchActiveForms();
  }, []);

  const isFormActive = (formName) => {
    const form = activeForms.find(f => f.applicationForm === formName);
    return form?.activeForm === 1;
  };

  const getFirstActiveForm = () => {
    const activeForm = activeForms.find(f => f.activeForm === 1);
    return activeForm?.applicationForm || null;
  };

  return (
    <ActiveFormsContext.Provider value={{ 
      activeForms, 
      loading, 
      fetchActiveForms, 
      isFormActive,
      getFirstActiveForm 
    }}>
      {children}
    </ActiveFormsContext.Provider>
  );
};
